// Multi-Screen Settings Types for Multi-Monitor Support
export const DEFAULT_MONITOR_ROLES = {
    worklist: false,
    viewer: false,
    primaryViewer: false,
    reporting: false,
};
export const DEFAULT_MULTI_SCREEN_SETTINGS = {
    enabled: false,
    hasPermission: false,
    layouts: [],
    activeLayoutId: null,
    viewerScreenIndex: 1,
    priorsScreenIndex: null,
    openFullscreen: true,
    popupsAllowed: false,
    monitorConfigs: [],
};
